import { z } from "zod";

export const LinearCustomConfig = z.object({
  backendBaseUrl: z.string(),
  frontendBaseUrl: z.string(),
  imageDownloadConcurrency: z.number(),
});

export const MockCustomConfig = z.object({
  backendBaseUrl: z.string(),
  frontendBaseUrl: z.string(),
});

export const ThirdPartyVideoTokenPayload = z.object({
  iss: z.string(),
  exp: z.number(),
  tpVideoId: z.string(),
});

export const ThirdPartyCustomConfig = z.union([
  LinearCustomConfig,
  MockCustomConfig,
]);

export const ThirdPartyExportConfig = z.object({
  availableExports: z.object({
    DOWNLOAD: z.object({ mode: z.literal("DEFAULT") }).optional(),
    LINK: z.object({ mode: z.literal("DEFAULT") }).optional(),
    VIMEO: z
      .object({
        mode: z.union([z.literal("DEFAULT"), z.literal("TP_AUTO_SEND")]),
      })
      .optional(),
  }),
});

export const ThirdPartyConfigQueryParams = z.object({
  token: z.string(),
});

export const ThirdPartyConfigDto = z.object({
  internalName: z.string(),
  displayName: z.string(),
  squareLogoSrc: z.string(),
  existingVideos: z
    .object({
      videoExternalId: z.string(),
      teamExternalId: z.string(),
    })
    .array(),
});

export type LinearCustomConfig = z.infer<typeof LinearCustomConfig>;
export type MockCustomConfig = z.infer<typeof MockCustomConfig>;
export type ThirdPartyCustomConfig = z.infer<typeof ThirdPartyCustomConfig>;
export type ThirdPartyExportConfig = z.infer<typeof ThirdPartyExportConfig>;
export type ThirdPartyVideoTokenPayload = z.infer<
  typeof ThirdPartyVideoTokenPayload
>;
export type ThirdPartyConfigQueryParams = z.infer<
  typeof ThirdPartyConfigQueryParams
>;
export type ThirdPartyConfigDto = z.infer<typeof ThirdPartyConfigDto>;
